import './RegionStatPanel.scss';
import Control from "../1. Core/Control";
import {PageMode, RegionStat} from "../10. Battle/types";
import NP from "../1. Core/NP";
import TopAppBar from "../1. Core/Controls/TopAppBar/TopAppBar";
import {loadFile} from "../1. Core/ScriptLoader";
import {IState} from "./StatesList";
import {ServerAPI} from "../1. Core/ServerAPI";
import TabControl from "../1. Core/Controls/TabControl/TabControl";
import TrainersList from "../7. Trainers/TrainersList";
import AthletesList from "./AthletesList";
import Dialog from "../1. Core/Controls/Dialog/Dialog";


export default class RegionStatPanel extends Control {
	private _State: IState;
	private _topAppBar: TopAppBar;

	private _infoNode: HTMLElement;
	private _textNode: HTMLElement;
	private _statNode: HTMLElement;
	private stat: RegionStat;
	private _textStat: HTMLElement;
	private _chartNode: HTMLElement;
	private _tabs: TabControl;
	private _tranersList: TrainersList;
	private athletesList: AthletesList;


	constructor(settings: object)
	{
		super(settings);
		this._render();
	}


	_initFields(settings: object)
	{
		this._State = null;
		super._initFields(settings);
	}

	_render()
	{
		this.np_render();

		this._topAppBar = new TopAppBar({
			Class: 'athletes-list__top-app-bar top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
			Caption: this._State.Name,
			ParentNode: this._root,
			ShowBackButton: true,
			ShowSearchButton: false
		});


		this._tabs = new TabControl({
			ParentNode: this._root,
			Items: [{
				Content: NP.RM.getString('Info'),
				Value: 'Info'
			}, {
				Content: NP.RM.getString('Trainers'),
				Value: 'Trainers'
			}, {
				Content: NP.RM.getString('MMA Athletes'),
				Value: 'Athletes'
			}],
			EvTabSelected: () =>
			{
				switch (this._tabs.getValue())
				{
					case 'Athletes':
						this.showAthletes();
						break;
					case 'Trainers':
						this.showTrainer();
						break;
					case 'Info':
						this.showInfo();
				}
			}
		});


		this._infoNode = NP.createNode(this._root, 'region-info-node');
		this._textNode = NP.createNode(this._infoNode, 'region-resume');

		this._statNode = NP.createNode(this._infoNode);

		this._textStat = NP.createNode(this._statNode, 'region-stat-text');
		this._chartNode = NP.createNode(this._statNode);


		this.refreshStat();
	}

	async refreshStat()
	{
		this.stat = await ServerAPI.get<RegionStat>(`/locations/stat/${this._State.Id}`)

		this.stat.WorldChampions = 1;
		this.stat.RUMedalist = 3;
		this.stat.EuroMedalist = 2;
		this.stat.SportClubCount = 12;


		this._textNode.innerHTML = `
			<img class="region-dash-img" src="${'/static/img/flags/' + this._State.ISO + '.png'}"/>
			<div class="region-text">
				<div>${this._State.Name} </div> 
				<div>${NP.RM.getString('SportClubs')}: ${this.stat.SportClubCount}</div>  
				<div>${NP.RM.getString('Trainers')}: ${this.stat.TrainersCount}</div> 
				<div>${NP.RM.getString('SumRating')}: ${this.stat.Rating}</div> 
			</div>`;

		this._textStat.innerHTML = `<div>
				<div>${NP.RM.getString('StudentCount')}: ${this.stat.StudentCount}</div>  
				<div>${NP.RM.getString('WorldChampions')}: ${this.stat.WorldChampions}</div> 
				<div>${NP.RM.getString('EuroMedalist')}: ${this.stat.EuroMedalist}</div> 
				<div>${NP.RM.getString('RUMedalist')}: ${this.stat.RUMedalist}</div> 
			</div>`;


		if (!(<any>window).Highcharts)
			return loadFile('highcharts.js').then(() => this.isLive() && this.refreshStat());


		let values = ['SP', 'HMS', 'IMS', 'CIS', 'Adult1', 'Adult2', 'Adult3', 'Youth1', 'Youth2', 'Youth3']
			 .filter(name => this.stat[name] > 0)
			 .map(name => ({
				 id: name,
				 name: NP.RM.getString(name),
				 y: this.stat[name]
			 }));

		let self = this;

		(window as any).Highcharts.chart(this._chartNode, {
			chart: {
				backgroundColor: 'transparent',
				plotBackgroundColor: null,
				plotBorderWidth: null,
				plotShadow: false,
				type: 'pie',
				width: 600,
				height: 400
			},
			exporting: {
				buttons: {
					contextButton: {
						enabled: false
					}
				}
			},
			credits: {
				enabled: false
			},
			title: {
				style: {
					display: 'none'
				}
			},
			tooltip: {
				enabled: false
			},
			plotOptions: {
				series: {
					point: {
						cursor: 'pointer',
						events: {
							click: function ()
							{
								self.onPointClick(this);
							}
						}
					}
				},
				backgroundColor: 'transparent',
				pie: {
					dataLabels: {
						enabled: true,
						style: {
							fontSize: '13px'
						},
						format: '<b>{point.name}</b>: {point.y}'
					}
				}
			},
			series: [{
				name: 'WinType',
				colorByPoint: true,
				data: values
			}]
		});
	}


	showAthletes()
	{
		NP.setIsVisible([this._tranersList, this._infoNode], false)

		if (!this.athletesList)
		{
			this.athletesList = new AthletesList({
				ParentNode: this._root,
				Mode: PageMode.mmaathletes,
				UseCity: true,
				ShowCategory: true,
				DrillDownFilter: {
					StateId: this._State.TopoId
				}
			});
			this.athletesList.getTopAppBar().setIsVisible(false)
		}
		else
			this.athletesList.setIsVisible(true);

		this.athletesList.setWidth(this.getWidth());
		this.athletesList.setHeight(this.getHeight());

		this.athletesList.refresh();
	}

	showInfo()
	{
		NP.setIsVisible([this._tranersList, this.athletesList], false)

		NP.setIsVisible(this._infoNode, true)
	}

	showTrainer()
	{
		NP.setIsVisible([this.athletesList, this._infoNode], false)


		if (!this._tranersList)
		{
			this._tranersList = new TrainersList({
				ParentNode: this._root,
				StateId: this._State.TopoId
			});
			this._tranersList.getTopAppBar().setIsVisible(false)
		}
		else
			this._tranersList.setIsVisible(true);

		this._tranersList.setWidth(this.getWidth());
		this._tranersList.setHeight(this.getHeight());

		this._tranersList.refresh();
	}

	setWidth(value: number)
	{
		super.setWidth(value);

		if (this._tranersList)
			this._tranersList.setWidth(value);

		if (this.athletesList)
			this.athletesList.setWidth(value);

	}

	onPointClick(point: any)
	{
		let cat = point.options.id;
		let list = new AthletesList({
			UseCity: true,
			Mode: PageMode.mmaathletes,
			DrillDownFilter: {
				StateId: this._State.TopoId,
				SportCategory: cat
			}
		})

		let dlg = new Dialog({
			ShowHeader: true,
			Width: 900,
			Mode: 'FullHeight',
			Caption: NP.RM.getString(cat),
			Class: 'nopad',
			ContentAutoFit: true,
			Content: list
		});

		list.getTopAppBar().setIsVisible(false)
		list.refresh();
		dlg.show();
		dlg.getCancelButton().setIsVisible(false);
	}

	setHeight(value: number)
	{
		super.setHeight(value);

		if (this._tranersList)
			this._tranersList.setHeight(value - 137);

		if (this.athletesList)
			this.athletesList.setHeight(value - 137);
	}

	getTopAppBar()
	{
		return this._topAppBar;
	}
}